import { InspectorControlsAppearance } from '@components/inspector-tabs';
import ClassDropdown from '@components/class-dropdown';
import { DEFAULT_CSS_CLASS } from '@constants';
import { FocusableIconSwitcher } from '@components/focusable-block-icon';

const InspectorAppearance = ({
  attributes: { blockClassNames, enableFocusableIcon },
  setAttributes,
}) => (
  <InspectorControlsAppearance>
    <ClassDropdown
      {...{
        blockClassNames,
        setAttributes,
        blockClassPrefix: DEFAULT_CSS_CLASS.RELATED_POSTS,
        initialOpen: true,
      }}
    />
    <FocusableIconSwitcher
      {...{
        enableFocusableIcon,
        setAttributes,
      }}
    />
  </InspectorControlsAppearance>
);

export default InspectorAppearance;
